export default __webpack_public_path__ + "static/media/ManageProfile.257fcb1e.svg";